import { theme } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

import { Grid } from '../../../Grid/Grid';
import { containerWidth } from '../../SimpleLayout.styles';
import { SimpleLayoutProps } from '../../SimpleLayout.types';

export const Root = styled(Grid)<StyledMods<Pick<SimpleLayoutProps, 'size'>>>`
    // padding is used instead of grid-gap for cases when we don't pass the component
    // to the Simple layout and layout will reserve the gap in case of "gap" usage
    padding-top: 24px;

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        padding-top: 16px;
    }

    ${containerWidth};
`;
